
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "HomeView",
  components: {},
  setup() {
    const isOpen = ref<boolean>(false);

    return { isOpen };
  },
});
